import { useContext, useMemo } from 'react';
import { filteredTextCallback } from './useGetFilteredParties';
import { SummaryContext } from '../../../../../shared/Summary/summaryContext';
import { useSelectCurrentOrder } from '../../../../../../selectors/order/selectCurrentOrder';
import { ePartyPurpose } from '../../../../../../ui-toolkit/enums/ePartyPurpose';
import { IParty } from '../../../../../../ui-toolkit/orders/interfaces/IParty';

export const useGetFilteredLenderClientParties = (): IParty[] => {
  const { filterText } = useContext(SummaryContext);
  const {
    data: { parties },
  } = useSelectCurrentOrder();
  const foundClientLenders = useMemo(() => {
    const clientLenderParties: IParty[] = [];
    const clientParty = parties.find((p) => p.purpose === ePartyPurpose.client);
    const lenderParty = parties.find((p) => p.purpose === ePartyPurpose.lender);
    const orderContactParty = parties.find((p) => p.purpose === ePartyPurpose.order_contact);
    [clientParty, lenderParty, orderContactParty].forEach((party) => {
      if (party) {
        clientLenderParties.push(party);
      }
    });
    return clientLenderParties;
  }, [parties]);
  return useMemo(() => {
    const filterCallback = filteredTextCallback(filterText);
    return foundClientLenders.filter(filterCallback);
  }, [foundClientLenders, filterText]);
};
